import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';

/** https://fmx.cpa.texas.gov/fm/pubs/payment/payee_setup/index.php */
export const EIN_VALIDATION_MASK = '00-0000000';
export const TIN_VALIDATION_MASK = '000-00-0000';

export function TINValidator(tinType: 'EIN'|'SSN'|'ATIN'|'ITIN'|'NA' = 'SSN'): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value || control.value.length === 0) {
            return null;
        }

        if (control.value.length !== 9) {
            return { invalidTINLength: true };
        }

        // cannot be all zeros
        if (tinType !== 'NA' && new RegExp(/^0{9}/).test(control.value)) {
            return { invalidValue: { value: tinType === 'EIN' ? EIN_VALIDATION_MASK : TIN_VALIDATION_MASK } };
        }

        switch(tinType) {
            case 'EIN':
                // https://www.irs.gov/businesses/small-businesses-self-employed/how-eins-are-assigned-and-valid-ein-prefixes
                // cannot lead with 00, 07, 08, 09
                if (new RegExp(/^0[0,7-9]/).test(control.value)) {
                    return { invalidPrefix: { prefix: (control.value as string).slice(0, 2) } };
                }

                break;
            case 'SSN':
                // cannot lead with 000 or 666
                if (new RegExp(/^0{3}|6{3}/).test(control.value.slice(0, 3))) {
                    console.log('match 000/666 pattern');
                    return { invalidPrefix: { prefix: (control.value as string).slice(0, 3) } };
                }

                // cannot lead with 9
                if (new RegExp(/^9/).test(control.value)) {
                    return { invalidPrefix: { prefix: '9' } };
                }

                break;
        }

        return null;
    };
}

@Directive({
    selector: '[validateTIN][formControlName],[validateTIN][formControl],[validateTIN][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => TINValidatorDirective),
            multi: true,
        },
    ],
})
export class TINValidatorDirective implements Validator
{
    @Input() tinType: 'EIN'|'SSN'|'ATIN'|'ITIN'|'NA' = 'SSN';

    validate(control: AbstractControl): { [key: string]: any } {
        const validator = TINValidator(this.tinType);
        return validator(control);
    }
}
